import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.bereich-logo-aktualisieren';
import * as api from '../../../clients/displaysteuerung';

@Injectable()
export class DisplaysteuerungBereichLogoAktualisierenEffects {

    BereichLogoAktualisieren$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BEREICH_LOGO_AKTUALISIEREN),
        mergeMap((x: ac.PostBereichLogoAktualisierenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBereichLogoAktualisieren(x.bereichLogoRequest).pipe(
                map((result: any) => {
                    return new ac.PostBereichLogoAktualisierenErfolgreichAction(result, x.bereichLogoRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBereichLogoAktualisierenFehlerAction(error, x.bereichLogoRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VerwaltenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VerwaltenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.VerwaltenCommandService);
        }
        return this.service;
    }
}
